const defaultKeys = ["sx", "as", "theme", "ownerState"];
function getShouldForwardProp(...keys) {
  return (prop) => {
    return !defaultKeys.concat(keys).includes(prop);
  };
}
export {
  getShouldForwardProp
};
//# sourceMappingURL=getShouldForwardProp.js.map
